import type { FileAccessLevel } from "@/lib/api";

/** パターンの最大長。サーバ側の検証と揃える。 */
const MAX_PATTERN_LENGTH = 200;

const FILE_ACCESS_LEVELS: Record<FileAccessLevel, true> = {
	denied: true,
	readOnly: true,
	confirmEdit: true,
	editable: true,
};

export function isFileAccessLevel(value: unknown): value is FileAccessLevel {
	return typeof value === "string" && value in FILE_ACCESS_LEVELS;
}

/** サーバ側 char.IsControl と同じ判定 (C0 と C1)。 */
export function hasControlCharacter(value: string): boolean {
	return Array.from(value).some((character) => {
		const code = character.codePointAt(0)!;
		return code <= 0x1f || (code >= 0x7f && code <= 0x9f);
	});
}

/**
 * 保存前のクライアント検証。サーバ側 (UserFileRuleMatcher) と同じ入力エラーを日本語で返す。
 */
export function filePolicyRulePatternError(pattern: string): string | null {
	if (pattern === "") return "パターンを入力してください。";
	if (pattern.length > MAX_PATTERN_LENGTH)
		return `パターンは${MAX_PATTERN_LENGTH}文字以内にしてください。`;
	if (hasControlCharacter(pattern)) return "パターンに制御文字は使用できません。";
	if (pattern.includes("\\"))
		return "グロブにバックスラッシュは使用できません。区切りは / を使ってください。";
	return null;
}
